import { z } from 'zod';
/**
 * Where a marketing consent was given. Recorded on the opt-in rather than inferred, both as evidence
 * of how consent was obtained and to show which placement actually converts. There is deliberately
 * no signup-time source: consent is never a side effect of creating an account or linking an
 * address.
 */
export const MarketingOptInSourceSchema = z.enum([
    /** Subscribed with the address already on the account — verified by OAuth or a confirmed link. */
    'milestone-prompt',
    /** Subscribed with an address typed into the prompt, which was never verified and is not a login. */
    'guest-typed',
]);
/**
 * A player's marketing consent as reported to the client.
 *
 * `email` is carried on the record rather than read from the account at send time, because the two
 * can diverge — changing a login address is not a re-consent. `revokedAt` is retained rather than
 * the record being deleted, so an honoured opt-out stays provable.
 */
export const MarketingOptInStatusSchema = z.object({
    email: z.string(),
    consentedAt: z.string(),
    source: MarketingOptInSourceSchema,
    revokedAt: z.string().optional(),
});
export const MarketingOptInResponseSchema = z.object({
    ok: z.boolean(),
    marketingOptIn: MarketingOptInStatusSchema,
});
export const MarketingDismissResponseSchema = z.object({
    ok: z.boolean(),
});
